module.exports = __webpack_public_path__ + "static/media/9-5.b9ced0e7.mp3";